import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';

import ChurchIcon from '@mui/icons-material/Church';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import LogoutIcon from '@mui/icons-material/Logout';

import { logout } from "api/Accounts/AccountsAPI";   // ✅ Correct import


export default function Navbar_Internal() {
  const theme = useTheme();

  const module_pages = [
    { name: 'Community', link: '/community/', color: theme.custom.modules.community.primary.dark },
    { name: 'Campaigns', link: '/campaigns/', color: theme.custom.modules.campaigns.primary.dark },
    { name: 'Interactions', link: '/interactions/text-messages/', color: theme.custom.modules.interactions.primary.dark },
  ];

  // ❗ Removed logout from list so it doesn't become a link
  const account_pages = [
    { name: 'Organisation', link: '/accounts/organisation/', icon: <ChurchIcon /> },
    // { name: 'Accounts', link: '/accounts/', icon: <ShoppingBagIcon /> },
    { name: 'Profile', link: '/accounts/profile/', icon: <AccountCircleIcon /> },
  ];

  // 🔥 Actual logout handler
  const handleLogout = async () => {
    try {
      await logout();
    } finally {
      window.location.href = "/"; // Redirect after logout
    }
  };

  return (
    <AppBar
      position="sticky"
      elevation={4}
      sx={{
        backgroundColor: theme.custom.ui.appBar.main.dark,
        color: theme.custom.base.text.primary.dark,
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid rgba(255,255,255,0.08)',
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ minHeight: 30, gap: 1 }}>
          
          {/* Brand name */}
          <Typography
            variant="subtitle1"
            noWrap
            component="a"
            href="/"
            sx={{
              ml: 1,
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 700,
              letterSpacing: '.05rem',
              color: 'inherit',
              textDecoration: 'none',
              transition: 'color 0.3s ease',
              '&:hover': {
                color: theme.custom.base.primary.dark,
              },
            }}
          >
            PATHWAYS
          </Typography>

          {/* Module Links */}
          <Box sx={{ flexGrow: 1, display: 'flex', gap: 2, ml: 3 }}>
            {module_pages.map((page) => (
              <Button
                key={page.name}
                href={page.link}
                sx={{
                  color: theme.custom.base.text.primary.dark,
                  fontWeight: 500,
                  fontSize: '0.8rem',
                  px: 1,
                  py: 0.5,
                  borderRadius: 0,
                  minWidth: 'auto',
                  borderBottom: '2px solid transparent',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    color: page.color,
                    borderBottom: `2px solid ${page.color}`,
                    backgroundColor: 'transparent',
                  },
                }}
              >
                {page.name}
              </Button>
            ))}
          </Box>

          {/* Account Icons + Logout */}
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', ml: 2 }}>

            {/* Account items */}
            {account_pages.map((page) => (
              <Tooltip key={page.name} title={page.name} placement="bottom">
                <IconButton
                  component="a"
                  href={page.link}
                  sx={{
                    color: theme.custom.base.text.primary.dark,
                    p: 0.5,
                    '&:hover': {
                      color: theme.custom.modules.accounts.primary.dark,
                    },
                  }}
                >
                  {page.icon}
                </IconButton>
              </Tooltip>
            ))}

            {/* 🔥 LOGOUT BUTTON */}
            <Tooltip title="Logout" placement="bottom">
              <IconButton
                onClick={handleLogout}
                sx={{
                  color: theme.custom.base.text.primary.dark,
                  p: 0.5,
                  '&:hover': {
                    color: theme.custom.functional.error.dark,
                  },
                }}
              >
                <LogoutIcon />
              </IconButton>
            </Tooltip>

          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
